import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      addPath: `/locales/add/{{ns}}?lang={{lng}}`,
      loadPath: `/locales/{{ns}}?lang={{lng}}`,
      crossDomain: true,
    },
    supportedLngs: ['en', 'de', 'fr', 'it'],
    fallbackLng: 'de',

    //! turn on locally to collate terms to translate
    // save missing keys
    saveMissing: true,
    // saveMissingTo: 'current',
    updateMissing: false,

    // have a translations namespace used everywhere in the app
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false, // we use content as keys

    interpolation: {
      formatSeparator: ',',
      escapeValue: false,
    },

    // react options
    react: {
      bindI18nStore: 'added removed',
      bindI18n: 'languageChanged',
      useSuspense: false,
    },

    // debug: true,
    order: ['navigator', 'localStorage'],
  });
export default i18n;
